import { useInfiniteQuery as useInfiniteQueryBase, } from '@tanstack/react-query';
import { request } from '../../request';
export function useInfiniteQuery({ key, query, variables, endpoint, options = {}, }) {
    let queryKey = key;
    if (variables && Array.isArray(key)) {
        queryKey = [...queryKey, variables];
    }
    else if (variables !== undefined) {
        queryKey = [queryKey, variables];
    }
    return useInfiniteQueryBase({
        queryKey: queryKey,
        queryFn: async ({ pageParam = 0 }) => {
            return request({
                query,
                variables: {
                    ...(variables || {}),
                    page: pageParam,
                },
                endpoint,
            });
        },
        initialPageParam: 0,
        getPreviousPageParam: firstPage => firstPage.meta.prevPage || undefined,
        getNextPageParam: lastPage => lastPage.meta.nextPage || undefined,
        ...options,
    });
}
//# sourceMappingURL=useInfiniteQuery.js.map